<template>
    <div class="form-element flex mb-2" :class="layoutClasses, {'w-full': editor}">
        <Label :id="id" :required="required" :label="label" v-if="label" />
        <QuillEditor
            :id="id"
            :name="name"
            :required="required"
            :disabled="disabled"
            ref="textarea"
            class="h-full border border-gray-300 rounded-b-md focus:outline-none focus:ring-0 focus:border-blue-dark-500"
            :class="{ 'border-red-600': error }"
            theme="snow"
            :toolbar="toolbar"
            @keyup="$emit('update:modelValue', modelValue)"
            :content="modelValue"
            @update:content="modelValue = $event"
            contentType="html"
            v-if="editor"
        />
        <!--        For some resaon v-model:content="modelValue" doesn't work anymore, so we need to use :content and @update-->
        <Error :error="error" class="!border-0" v-if="error && editor" />
        <div class="form-field-wrapper" v-if="!editor">
            <textarea
                :id="id"
                :name="name"
                :value="modelValue"
                :required="required"
                :disabled="disabled"
                :maxlength="maxlength"
                @input="$emit('update:modelValue', $event.target.value)"
                ref="textarea"
                class="form-field flex-1 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-0 focus:border-blue-dark-500"
                :class="{ 'border-red-600': error }, { 'bg-gray-200 cursor-not-allowed': disabled }"
                :rows="rows"
            />
            <Error :error="error" v-if="error" />
        </div>
    </div>
</template>

<script>
import Label from "./Label";
import Error from "./Error";

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

export default {
    components: {
        Label,
        Error,
        QuillEditor
    },
    emits: ['update:modelValue'],
    props: {
        layout: {
            type: String,
            default: 'horizontal',//vertical
        },
        label: {
            type: String,
        },
        name: {
            type: String,
            required: true
        },
        id: {
            type: String,
            default: (props) => props.name,
        },
        modelValue: {
            type: String
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        error: {
            type: String
        },
        rows: {
            type: Number,
            default: 3
        },
        editor: {
            type: Boolean,
            default: false
        },
        toolbar: {
            type: [String, Array],
            default: 'essential'//minimal, full, none, ['bold', 'italic', 'underline', 'sub', 'super']
        },
        maxlength: {
            type: String
        },
    },
    computed: {
        layoutClasses() {
            if (this.layout == 'vertical') {
                return 'flex-col';
            } else {
                return 'items-start';
            }
        }
    },
}
</script>

<style>
.ql-hidden {
    display: none;
}
</style>

<style scoped>
.form-field-wrapper {
    line-height: 0;
}
</style>
